<template>
  <el-form :model="brandForm" :rules="rules" ref="brandForm" label-width="15%" class="demo-brandForm" v-loading.body="fetchLoding">
    <el-form-item :label="generateCustomizeString('brandName')" prop="brand_name">
      <el-input v-model="brandForm.brand_name"></el-input>
    </el-form-item>
    <el-form-item :label="generateCustomizeString('brandLogo')" prop="branch_pic_url">
      <el-upload action="https://upload-z2.qiniup.com" :limit="1" :drag="true" :on-success="handleAvatarSuccess" :on-error="handleError" :before-upload="beforeAvatarUpload" :data="qiniuData">
        <img v-if="brandForm.branch_pic_url" :src="displayBrandLogoUrl">
        <div v-else>
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">{{generateCustomizeString('dragFiles')}}
            <em>{{generateCustomizeString('uploadFiles')}}</em>
          </div>
        </div>
        <div class="el-upload__tip" slot="tip">{{generateCustomizeString('fileLimit')}}</div>
      </el-upload>
    </el-form-item>
    <el-form-item :label="generateCustomizeString('brandInitials')" prop="alias">
      <el-input v-model="brandForm.alias" :maxlength="1"></el-input>
    </el-form-item>
    <el-form-item :label="generateCustomizeString('sortWeight')" prop="sort_by">
      <el-input v-model="brandForm.sort_by" min="0" max="999" type="number" @change="setInt()"></el-input>
    </el-form-item>
    <el-form-item :label="generateCustomizeString('brandActivity')" prop="is_show">
      <el-switch v-model="brandForm.is_show" :active-text="generateCustomizeString('brandReady')" :inactive-text="generateCustomizeString('brandWaitForReview')">
      </el-switch>
    </el-form-item>
    <el-form-item :label="generateCustomizeString('brandDetails')" prop="desc">
      <tinymce :height="200" v-model="brandForm.desc"></tinymce>
    </el-form-item>
    <el-form-item>
      <el-button v-if="isEdit" type="primary" @click="submitForm('brandForm')" plain>{{generateCustomizeString('update')}} </el-button>
      <el-button v-if="!isEdit && !isView" type="primary" @click="submitForm('brandForm')">{{generateCustomizeString('create')}}</el-button>
    </el-form-item>

    <el-button round type="primary" style="position: fixed; right: 50px; bottom: 50px; z-index: 10000;" icon="el-icon-arrow-left" @click="$router.go(-1)">{{ generateCustomizeString('return') }}</el-button>
  </el-form>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import Tinymce from '@/components/Tinymce'
import request from '@/utils/request'

const defaultBrand = {
  brand_name: '',
  branch_pic_url: '',
  pictures: '',
  alias: '',
  sort_by: 0,
  create_at: '',
  is_show: false,
  desc: ''
}

export default {
  name: 'BrandDetail',
  components: {
    Tinymce
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    isView: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      brandForm: Object.assign({}, defaultBrand),
      qiniuData: {
        token: ''
      },
      fetchLoding: false,
      rules: {
        brand_name: [
          {
            required: true,
            message: this.generateCustomizeString('pleaseEnter'),
            trigger: 'blur'
          }
        ],
        branch_pic_url: [
          {
            required: true,
            message: this.generateCustomizeString('pleaseEnter'),
            trigger: 'blur'
          }
        ],
        alias: [
          {
            required: true,
            pattern: '^[A-Za-z]+$',
            message: this.generateCustomizeString('pleaseEnter'),
            trigger: 'blur'
          }
        ],
        sort_by: [
          {
            // required: true,
            type: 'number',
            // pattern: '^[0-9]',
            message: this.generateCustomizeString('pleaseEnter'),
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    generateCustomizeString,
    setInt(event) {
      this.brandForm.sort_by = (parseInt(this.brandForm.sort_by) > 999) ? 999 : parseInt(this.brandForm.sort_by)
    },
    submitForm(formName) {
      if (this.isEdit) {
        // update
        this.updateBrand()
      } else {
        // create
        this.createBrand()
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    fetchBrand() {
      if (this.fetchLoding) return
      this.fetchLoding = true

      request({
        url: '/brand/' + this.brandId,
        method: 'get'
      })
        .then(res => {
          if (res.status === 0) {
            for (const i in this.brandForm) {
              this.brandForm[i] = res.data[i]
              if (i === 'is_show') {
                this.brandForm.is_show = res.data[i] === 1
              }
            }
          }
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          this.fetchLoding = false
        })
    },
    fetchUploadToken() {
      request({
        url: '/upload-token',
        method: 'get'
      })
        .then(res => {
          this.qiniuData.token = res.data['token']
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleAvatarSuccess(res, file) {
      // 上传成功后在图片框显示图片
      // 更改了key
      this.brandForm.pictures = res.key

      this.brandForm.branch_pic_url = 'https://img.nzmai.com.cn/' + res.key
      console.log(res)
    },
    handleError(res) {
      // 显示错误
      console.log(res)
    },
    beforeAvatarUpload(file) {
      // 在图片提交前进行验证
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG && !isPNG) {
        this.$message.error(this.generateCustomizeString('jpgpngonly'))
      }
      if (!isLt2M) {
        this.$message.error(this.generateCustomizeString('lessThan2MB'))
      }

      return (isJPG || isPNG) && isLt2M
    },
    createBrand() {
      var data = {
        brand_name: this.brandForm.brand_name,
        alias: this.brandForm.alias,
        pictures: this.brandForm.pictures,
        sort_by: this.brandForm.sort_by,
        is_show: this.brandForm.is_show,
        desc: this.brandForm.desc
      }

      request({
        url: 'brand',
        method: 'post',
        data
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('brandCreated'),
              type: 'success'
            })

            this.$store.dispatch('delCurrentViews', {
              view: this.$route,
              $router: this.$router
            })
            this.$router.replace({ name: 'Brand' })
          } else {
            this.$message.error(this.generateCustomizeString('brandCreatFailed'))
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error(this.generateCustomizeString('brandCreatFailed'))
        })
    },
    updateBrand() {
      var data = {
        brand_name: this.brandForm.brand_name,
        alias: this.brandForm.alias,
        pictures: this.brandForm.pictures,
        sort_by: this.brandForm.sort_by,
        is_show: this.brandForm.is_show,
        desc: this.brandForm.desc
      }
      request({
        url: 'brand/' + this.brandId,
        method: 'put',
        data
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('brandUpdated'),
              type: 'success'
            })
            this.$router.replace({ name: 'Brand' })
          } else {
            this.$message.error(this.generateCustomizeString('brandUpdateFailed'))
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error(this.generateCustomizeString('brandUpdateFailed'))
        })
    }
  },
  created() {
    this.fetchUploadToken()
    if (this.isEdit || this.isView) {
      this.fetchBrand()
    } else {
      this.brandForm = Object.assign({}, defaultBrand)
    }
  },
  computed: {
    displayBrandLogoUrl() {
      return (
        this.brandForm.branch_pic_url +
        '?imageView2/0/w/360/h/180/q/75|imageslim'
      )
    },
    brandId() {
      return this.$route.params.brandId
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.demo-brandForm {
  padding: 50px 50px 0px 50px;
}
</style>
